import { render, staticRenderFns } from "./listTaskAgruped.vue?vue&type=template&id=825c7114&"
import script from "./listTaskAgruped.vue?vue&type=script&lang=js&"
export * from "./listTaskAgruped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports